import * as z from 'zod'
import { entityTypeNames } from '../entity-types.js'

export const conditionKinds = ['type', 'tag', 'space'] as const

export const conditionSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('type'), entityType: z.enum(entityTypeNames) }),
  z.object({ kind: z.literal('tag'), tag: z.string() }),
  z.object({ kind: z.literal('space'), spaceId: z.string() }),
])

export type Condition = z.infer<typeof conditionSchema>
